import { render, staticRenderFns } from "./CollaborateurDetails.vue?vue&type=template&id=3f1043a8&"
import script from "./CollaborateurDetails.vue?vue&type=script&lang=js&"
export * from "./CollaborateurDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports